import InputF from './Input.vue';
import NumberF from './Number.vue';
import PasswordF from './Password.vue';

export const ComponentesFlex = {
	InputF,
	NumberF,
	PasswordF
}